// Utilitaire pour supprimer les erreurs de géolocalisation système (iOS/macOS)
// Ces erreurs sont générées par le système d'exploitation et ne peuvent pas être évitées
// mais elles polluent la console en développement

let originalError = null;
let originalWarn = null;
let isSuppressing = false;

export const suppressLocationErrors = () => {
  if (isSuppressing) return;
  
  isSuppressing = true;
  
  // Sauvegarder les fonctions originales
  originalError = console.error;
  originalWarn = console.warn;
  
  // Remplacer console.error pour filtrer les erreurs de géolocalisation
  console.error = (...args) => {
    const message = args.join(' ');
    
    // Ignorer les erreurs CoreLocation et de géolocalisation système
    if (
      message.includes('CoreLocationProvider') ||
      message.includes('kCLErrorLocationUnknown') ||
      message.includes('CoreLocation framework reported')
    ) {
      return; // Ne pas afficher ces erreurs
    }
    
    // Afficher les autres erreurs normalement
    originalError.apply(console, args);
  };
  
  // Remplacer console.warn pour filtrer les avertissements de géolocalisation
  console.warn = (...args) => {
    const message = args.join(' ');
    
    // Ignorer les avertissements de géolocalisation système
    if (
      message.includes('CoreLocationProvider') ||
      message.includes('kCLErrorLocationUnknown') ||
      message.includes('CoreLocation framework reported')
    ) {
      return; // Ne pas afficher ces avertissements
    }
    
    // Afficher les autres avertissements normalement
    originalWarn.apply(console, args);
  };
};

export const restoreLocationErrors = () => {
  if (!isSuppressing) return;
  
  isSuppressing = false;
  
  // Restaurer les fonctions originales
  if (originalError) {
    console.error = originalError;
  }
  if (originalWarn) {
    console.warn = originalWarn;
  }
};

// Intercepter les erreurs globales non capturées
const originalOnError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  const messageStr = String(message);
  
  // Ignorer les erreurs CoreLocation
  if (
    messageStr.includes('CoreLocationProvider') ||
    messageStr.includes('kCLErrorLocationUnknown') ||
    messageStr.includes('CoreLocation framework reported')
  ) {
    return true; // Empêcher l'affichage de l'erreur
  }
  
  // Laisser les autres erreurs être gérées normalement
  if (originalOnError) {
    return originalOnError(message, source, lineno, colno, error);
  }
  return false;
};

// Intercepter les erreurs non capturées via addEventListener
window.addEventListener('error', (event) => {
  const message = event.message || '';
  
  // Ignorer les erreurs CoreLocation
  if (
    message.includes('CoreLocationProvider') ||
    message.includes('kCLErrorLocationUnknown') ||
    message.includes('CoreLocation framework reported')
  ) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
}, true);

// Activer automatiquement en développement et production
suppressLocationErrors();

// Intercepter aussi les messages de la console du navigateur (pour les erreurs système)
const originalLog = console.log;
console.log = (...args) => {
  const message = args.join(' ');
  if (
    message.includes('CoreLocationProvider') ||
    message.includes('kCLErrorLocationUnknown') ||
    message.includes('CoreLocation framework reported')
  ) {
    return; // Ne pas afficher
  }
  originalLog.apply(console, args);
};

